<script setup>
import { computed, onMounted } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { useFunctionGetter, useStore } from 'dashboard/composables/store';
import { useUISettings } from 'dashboard/composables/useUISettings';
import WooCommerceBrandIcon from '../../WooCommerceBrandIcon.vue';
import {
  hasWooCommerceConversationModeHooks,
  WOO_COMMERCE_CONVERSATION_PANEL_MODES,
} from '../../../helpers/stores';

defineProps({
  isContactSidebarOpen: {
    type: Boolean,
    default: false,
  },
  isCopilotPanelOpen: {
    type: Boolean,
    default: false,
  },
});

const store = useStore();
const { uiSettings, updateUISettings } = useUISettings();
const integration = useFunctionGetter(
  'integrations/getIntegration',
  'woocommerce'
);

const isWooCommercePanelOpen = computed(
  () => uiSettings.value.is_woocommerce_sidebar_open
);
const hasSidebarModeHooks = computed(() =>
  hasWooCommerceConversationModeHooks(
    integration.value?.hooks || [],
    WOO_COMMERCE_CONVERSATION_PANEL_MODES.SIDEBAR
  )
);

const handleToggle = () => {
  updateUISettings({
    is_contact_sidebar_open: false,
    is_copilot_panel_open: false,
    is_woocommerce_sidebar_open: true,
  });
};

onMounted(() => {
  store.dispatch('integrations/get', 'woocommerce').catch(() => {});
});
</script>

<template>
  <template v-if="hasSidebarModeHooks">
    <Button
      v-show="!isWooCommercePanelOpen"
      v-tooltip.bottom="$t('CONVERSATION_SIDEBAR.WOOCOMMERCE.PANEL_TOOLTIP')"
      ghost
      slate
      sm
      class="!rounded-full transition-all duration-[250ms] ease-out active:!scale-95 active:duration-75"
      :class="{
        'bg-n-alpha-2 active:!brightness-105 active:shadow-sm':
          isWooCommercePanelOpen,
      }"
      @click="handleToggle"
    >
      <template #icon>
        <WooCommerceBrandIcon :size="18" :rounded="false" />
      </template>
    </Button>
  </template>
  <template v-else />
</template>
